import { createFileRoute } from '@tanstack/react-router';

import { ScreenStub } from '@/components/layout/ScreenStub';

export const Route = createFileRoute('/leagues/$leagueId/waivers')({
  component: Screen,
});

function Screen() {
  return (
    <ScreenStub
      title="Waivers"
      capability="leagues.view"
      planned="Pending claims with priority order, claimant, player in/out, FAAB bid and process time; a drag-reorderable priority list; and waiver history with outcomes."
    />
  );
}
